import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../../Contexts/AuthContext";

const AdminRoute = ({ children }) => {
  console.log("admin route");
  const { isAdmin, isLoggedin } = useAuthContext();
  const location = useLocation();
  if (!isAdmin) {
    if (isLoggedin) return <Navigate to={"/dashboard"} replace />;
    return <Navigate to={"/login"} replace state={{ from: location }} />;
  }
  return children;
};

export default AdminRoute;
